<div class="cons" *ngIf="lineas">
  <h3>Qué pasará al liberar</h3>
  <ul>
    <li *ngFor="let l of lineas">{{ l.texto }}<ng-container *ngIf="l.sap">&ngsp;<b class="num">{{ l.sap }}</b>.</ng-container></li>
  </ul>
</div>
<p class="help" *ngIf="!lineas">Elige una entrega para ver qué pasará al liberarla.</p>
